export default __webpack_public_path__ + "img/tg.1dcf3369.svg";